import { styled } from "goober";
import type { ReactNode } from "react";
import {
  InstructionsStep,
  StepHeading,
} from "../ConnectorModal/InstructionsStep";
import { MarkdownText } from "../ConnectorModal/MarkdownItem";
import { Icon } from "../Icon";
import { Markdown } from "../Markdown";
import { Text } from "../Text";
import { Toggle } from "../Toggle";

const GuideLabel = styled("div")`
  display: flex;
  align-items: center;
  opacity: 0.3;
`;

export function GuideToggle({
  isOn,
  onToggle,
  disabled,
}: {
  isOn: boolean;
  onToggle: () => void;
  disabled?: boolean;
}) {
  return (
    <>
      <GuideLabel>
        <Text variant="text-small-md">Guide</Text>
      </GuideLabel>
      <Toggle
        isOn={isOn}
        onToggle={onToggle}
        ariaLabel="Guide"
        disabled={disabled}
      />
      <Icon name="slash" size={12} color="var(--border-alpha)" />
    </>
  );
}

export function GuideStep({
  title,
  lead,
  guide,
  showGuide,
  children,
}: {
  title: string;
  lead?: ReactNode;
  guide?: string;
  showGuide: boolean;
  children?: ReactNode;
}) {
  if (!showGuide) {
    return (
      <>
        {lead}
        {children}
      </>
    );
  }
  return (
    <InstructionsStep>
      <StepHeading style={{ marginBottom: guide ? -6 : 0 }}>
        <Text variant="text-regular-md">{title}</Text>
      </StepHeading>
      {guide && <GuideText>{guide}</GuideText>}
      {lead}
      {children}
    </InstructionsStep>
  );
}

export function GuideText({ children }: { children: string }) {
  return (
    <MarkdownText>
      <Text variant="text-regular">
        <Markdown>{children}</Markdown>
      </Text>
    </MarkdownText>
  );
}
